import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CloudImageEditorBase } from './CloudImageEditorBase.js';
import { classNames } from './lib/classNames.js';
export class EditorButtonControl extends CloudImageEditorBase {
  constructor() {
    super(...arguments);
    _defineProperty(this, "init$", _objectSpread(_objectSpread({}, this.init$), {}, {
      active: false,
      title: '',
      icon: '',
      'on.click': null
    }));
  }
  initCallback() {
    super.initCallback();
    this._titleEl = this.ref['title-el'];
    this._iconEl = this.ref['icon-el'];
    this.setAttribute('role', 'button');
    if (this.tabIndex === -1) {
      this.tabIndex = 0;
    }
    this.sub('title', title => {
      let titleEl = this._titleEl;
      if (titleEl) {
        this._titleEl.style.display = title ? 'block' : 'none';
      }
    });
    this.sub('active', active => {
      this.className = classNames({
        active: active,
        not_active: !active
      });
    });
    this.sub('on.click', onClick => {
      this.onclick = onClick;
    });
  }
}
EditorButtonControl.template = /* HTML */"\n  <div class=\"before\"></div>\n  <lr-icon size=\"20\" set=\"@name: icon;\"></lr-icon>\n  <div class=\"title\" ref=\"title-el\">{{title}}</div>\n";